module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent.b389f3ca.jpg";